import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

class Flowbar extends Component {
  constructor(props) {
    super(props)
  }

  isItemActive(component) {
    return component.status.indexOf('active') > -1
  }
  isItemDone(component) {
    return component.status.indexOf('passed') > -1
  }

  getFlowbarItemModifierClass(id) {
    if (this.isItemActive(this.props.components[id])) {
      return this.props.styles['item--active']
    }

    if (this.isItemDone(this.props.components[id])) {
      return this.props.styles['item--done']
    }

    return
  }

  renderComponents() {
    return this.props.widget.components
      .filter(
        k => k.indexOf(this.props.widget.name) > -1 && this.props.components[k]
      )
      .map(id => {
        if(id === 'FLOW_BAR-STEP_1' || id === 'FLOW_BAR-STEP_2' || this.props.components[id].status[0] === 'last'){
          return (
            <li
              key={this.props.components[id].name}
              {...css(
                this.props.styles.item,
                this.getFlowbarItemModifierClass(id)
              )}
            >
              <span>{this.props.components[id].value} </span>
            </li>
          )
        }
      })
  }

  render() {
    return (
      <ul {...css(this.props.styles.flowbar)}>{this.renderComponents()}</ul>
    )
  }
}

Flowbar.propTypes = {
  widget: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired
}

const mapStateToProps = (state /*, ownProps*/) => {
  const { components } = state
  return { components }
}

export default connect(mapStateToProps)(withStyles(Styles)(Flowbar))



// WEBPACK FOOTER //
// ./components/flowbar/index.js